<template>
  <v-card class="kanban-card" :class="type" :ripple="false" width="275px" elevation="0" @click="$emit('click')">
    <v-card-text class="pa-3">
      <v-container class="pt-0" fluid>
        <v-row>
          <span class="status-box">{{ capitalize(type) }}</span>
          <span class="status-date ml-2">
            <span>{{ info.date ? DateTime.fromFormat(info.date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy') : '-' }} | </span>

            <span>{{ info.time || '-' }}</span>
            <span></span>
          </span>
          <v-spacer />

          <v-menu>
            <template v-slot:activator="{ on }">
              <mf-icon class="more-icon" v-on="on"> more_vert </mf-icon>
            </template>
            <v-list>
              <v-list-item v-if="info.status === 'AWAITING'" @click="finish">
                <v-list-item-title>Concluir</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('print', info)">
                <v-list-item-title>Imprimir</v-list-item-title>
              </v-list-item>
              <v-list-item @click="cancel">
                <v-list-item-title>Cancelar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </v-container>
      <div class="info-box">
        <p class="info-text">
          <strong>Cliente: </strong>
          <span>{{ info.user.name }}</span>
        </p>

        <p class="info-text">
          <strong>Data/hora do pedido: </strong>
          <span>{{ DateTime.fromISO(info.purchase.timestamp).toFormat('dd/MM/yyyy | HH:mm') }}</span>
        </p>

        <p class="info-text">
          <strong>Reponsável: </strong>
          <span>{{ info.agent }}</span>
        </p>

        <p class="info-text">
          <strong>Loja: </strong>
          <span>{{ info.unit.name }}</span>
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import capitalize from 'lodash/capitalize'
import { MUTATION_UPDATE_KANBAN_CARD_STATUS } from '../../graphql'
import { DateTime } from 'luxon'

export default {
  props: {
    info: Object,
  },
  data: () => ({
    capitalize: capitalize,
    DateTime: DateTime,
  }),
  computed: {
    type() {
      return this.info.purchase.delivery_method === 'DELIVERY' ? 'entrega' : 'retirada'
    },
  },
  methods: {
    cancel() {
      this.$confirm({
        title: 'Cancelar pedido',
        message: 'Tem certeza que deseja cancelar esse pedido? Após cancelado, ele irá para a página de histórico.',
        confirmText: 'Cancelar',
        cancelText: 'Voltar',
      })
        .then(async () => {
          await this.changeToStatus('CANCELED')
        })
        .catch(() => {})
    },
    finish() {
      this.$confirm({
        title: 'Concluir pedido',
        message: 'Tem certeza que deseja concluir esse pedido? Após concluído, ele irá para a página de histórico.',
        confirmText: 'Concluir',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.changeToStatus('CONCLUDED')
        })
        .catch(() => {})
    },
    async changeToStatus(status) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_KANBAN_CARD_STATUS,
          variables: {
            _id: this.info._id,
            status: status,
          },
        })

        this.$emit('update:info', data.updateKanbanCardStatus)
      } catch (error) {
        this.$snackbar({ message: 'Erro ao alterar status', snackbarColor: 'error' })
      }
    },
  },
}
</script>

<style lang="scss">
.kanban-card {
  border-width: 1px;
  border-style: solid;
  user-select: none;
  cursor: pointer;

  .status-box {
    padding: 4px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.25;
    letter-spacing: 0.19px;
    color: $branco;
  }

  .status-date {
    opacity: 0.8;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.19px;
    color: $preto;
  }

  .info-box {
    .info-text {
      opacity: 0.8;
      font-size: 12px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      margin-bottom: 4px;
      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }
  &.entrega {
    border-color: $verde-l20;
    .status-box {
      background-color: $marca-1;
    }
  }
  &.retirada {
    border-color: $marca-0-l40;
    .status-box {
      background-color: $marca-0-l40;
    }
  }

  .more-icon {
    opacity: 0.7;
  }
}
</style>
